module.exports = __webpack_public_path__ + "static/hcm-slider2-077b4a668401471006cf8be4685d3f64.jpeg";